import React from 'react';
import { FaSquareXTwitter } from "react-icons/fa6";

import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import './footer.css';

const Footer = () => {
  
  let getYear = () => {
    let currentYear = new Date().getFullYear();
    return currentYear;
  };
  
  return (
    <footer>
      <a href="#home" className="footer__logo">Rashid pbi</a>
      <ul className="permalinks">
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
      <div className="footer__socials">
      <a href="https://www.linkedin.com/in/rashidpbi/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/rashidpbi" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://x.com/rashidpbi" target="_blank" rel="noreferrer" ><FaSquareXTwitter /></a>
      </div>
      <div className="footer__copyright">
        <small>&copy; PBI {getYear()}. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
